export type TalentPanelTranslations = {
  area: string;
  areaMissing: string;
  areaPlaceholder: string;
  cancelEdit: string;
  close: string;
  date: string;
  edit: string;
  editHeading: string;
  empty: string;
  formHeading: string;
  historyHeading: string;
  loadError: string;
  outcome: string;
  outcomeMissing: string;
  outcomePlaceholder: string;
  save: string;
  saveChanges: string;
  saveError: string;
  title: string;
  updateError: string;
};

export const talentPanelTranslations: TalentPanelTranslations = {
  area: 'Area or position',
  areaMissing: 'Area not given',
  areaPlaceholder: 'e.g. Team Leader',
  cancelEdit: 'Cancel editing',
  close: 'Close',
  date: 'Panel date',
  edit: 'Edit entry',
  editHeading: 'Edit panel',
  empty: 'No panels recorded yet.',
  formHeading: 'New panel',
  historyHeading: 'Previous panels ({{total}})',
  loadError: 'Could not load previous panels. Close the window and open it again.',
  outcome: 'Outcome and conclusions',
  outcomeMissing: 'Conclusions not given',
  outcomePlaceholder: 'Write down the panel conclusions...',
  save: 'Save panel',
  saveChanges: 'Save changes',
  saveError: 'Could not save the panel. Try again.',
  title: 'Development panel',
  updateError: 'Could not save the changes. Try again.',
};
